// extracted by mini-css-extract-plugin
module.exports = {"container":"Graduation_container__2xiSB","img":"Graduation_img__3tIk_"};